import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import mixins from './mixins';
import VueClipboard from 'vue-clipboard2'
 
Vue.use(VueClipboard);

// register mixins
Vue.mixin(mixins);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  mixins,
  render: h => h(App)
}).$mount('#app')
